// GENERATED by scripts/build-small-bodies.mjs. Do not edit by hand.
// The small bodies drawn in their real shapes (src/smallbodies/): the model,
// the map where a spacecraft mapped the surface (relative to the mean, sRGB,
// 3x the mean at full scale), the mean albedo and its display value,
// the spin pole in scene coordinates and the rotation. artistic: no image has
// resolved the surface, so the shading draws an artistic one.
// Sources and licences: docs/textures/small-bodies.md.
export const SMALL_BODY_REL_MAX = 3;
export const SMALL_BODY_MODELS = {
  "bennu": {
    "id": "bennu",
    "name": "Bennu",
    "model": "/models/smallbodies/bennu.glb",
    "modelBytes": 324256,
    "triangles": 60000,
    "reach": 1.1815,
    "axes": [
      1.149,
      1.016,
      1.093
    ],
    "radiusKm": 0.2452,
    "map": "/textures/smallbodies/bennu.jpg",
    "mobileMap": "/textures/smallbodies/mobile/bennu.jpg",
    "mapColour": false,
    "mapValidLat": [
      -77,
      81
    ],
    "albedo": 0.044,
    "display": 0.0931,
    "tint": [
      0.98,
      1,
      1.03
    ],
    "style": "rubble",
    "artistic": false,
    "pole": [
      0.037729,
      -0.993216,
      -0.109993
    ],
    "periodHours": 4.296057,
    "tumble": null
  },
  "ryugu": {
    "id": "ryugu",
    "name": "Ryugu",
    "model": "/models/smallbodies/ryugu.glb",
    "modelBytes": 391536,
    "triangles": 60000,
    "reach": 1.1786,
    "axes": [
      1.138,
      1.084,
      1.139
    ],
    "radiusKm": 0.448,
    "map": "/textures/smallbodies/ryugu.jpg",
    "mobileMap": "/textures/smallbodies/mobile/ryugu.jpg",
    "mapColour": false,
    "mapValidLat": [
      -52,
      54
    ],
    "albedo": 0.045,
    "display": 0.0944,
    "tint": [
      1,
      1,
      1
    ],
    "style": "rubble",
    "artistic": false,
    "pole": [
      -0.044626,
      -0.999004,
      -0.000516
    ],
    "periodHours": 7.63262,
    "tumble": null
  },
  "eros": {
    "id": "eros",
    "name": "Eros",
    "model": "/models/smallbodies/eros.glb",
    "modelBytes": 207768,
    "triangles": 49151,
    "reach": 2.0921,
    "axes": [
      1.938,
      0.71,
      1.002
    ],
    "radiusKm": 8.42,
    "map": "/textures/smallbodies/eros.jpg",
    "mobileMap": "/textures/smallbodies/mobile/eros.jpg",
    "mapColour": true,
    "mapValidLat": null,
    "albedo": 0.25,
    "display": 0.2641,
    "tint": [
      1,
      1,
      1
    ],
    "style": "regolith",
    "artistic": false,
    "pole": [
      0.936495,
      0.196839,
      -0.290227
    ],
    "periodHours": 5.270258,
    "tumble": null
  },
  "vesta": {
    "id": "vesta",
    "name": "Vesta",
    "model": "/models/smallbodies/vesta.glb",
    "modelBytes": 322780,
    "triangles": 60000,
    "reach": 1.1185,
    "axes": [
      1.076,
      0.891,
      1.086
    ],
    "radiusKm": 262.7,
    "map": "/textures/smallbodies/vesta.jpg",
    "mobileMap": "/textures/smallbodies/mobile/vesta.jpg",
    "mapColour": false,
    "mapValidLat": [
      -90,
      74
    ],
    "albedo": 0.38,
    "display": 0.3395,
    "tint": [
      1.06,
      1,
      0.9
    ],
    "style": "regolith",
    "artistic": false,
    "pole": [
      0.466256,
      0.845485,
      0.260308
    ],
    "periodHours": 5.342128,
    "tumble": null
  },
  "pallas": {
    "id": "pallas",
    "name": "Pallas",
    "model": "/models/smallbodies/pallas.glb",
    "modelBytes": 299176,
    "triangles": 51200,
    "reach": 1.1269,
    "axes": [
      1.093,
      0.846,
      1.02
    ],
    "radiusKm": 256,
    "map": null,
    "mobileMap": null,
    "mapColour": false,
    "mapValidLat": null,
    "albedo": 0.155,
    "display": 0.1982,
    "tint": [
      0.97,
      1,
      1.04
    ],
    "style": "regolith",
    "artistic": true,
    "pole": [
      0.717823,
      -0.258819,
      -0.646331
    ],
    "periodHours": 7.81322,
    "tumble": null
  },
  "hygiea": {
    "id": "hygiea",
    "name": "Hygiea",
    "model": "/models/smallbodies/hygiea.glb",
    "modelBytes": 306952,
    "triangles": 51200,
    "reach": 1.0585,
    "axes": [
      0.986,
      0.984,
      1.044
    ],
    "radiusKm": 216.5,
    "map": null,
    "mobileMap": null,
    "mapColour": false,
    "mapValidLat": null,
    "albedo": 0.063,
    "display": 0.1155,
    "tint": [
      1,
      1,
      0.98
    ],
    "style": "regolith",
    "artistic": true,
    "pole": [
      0.526359,
      -0.48481,
      0.698502
    ],
    "periodHours": 13.82559,
    "tumble": null
  },
  "apophis": {
    "id": "apophis",
    "name": "Apophis",
    "model": "/models/smallbodies/apophis.glb",
    "modelBytes": 345368,
    "triangles": 60000,
    "reach": 1.4125,
    "axes": [
      1.336,
      0.916,
      1.075
    ],
    "radiusKm": 0.17,
    "map": null,
    "mobileMap": null,
    "mapColour": false,
    "mapValidLat": null,
    "albedo": 0.35,
    "display": 0.3231,
    "tint": [
      1.08,
      1,
      0.88
    ],
    "style": "rubble",
    "artistic": true,
    "pole": [
      -0.019244,
      -0.998806,
      0.0449
    ],
    "periodHours": 30.56,
    "tumble": {
      "precessionHours": 27.3743,
      "rotationHours": 262.168,
      "theta": 19.9
    }
  }
};
